<template>
    <div class=" ">
        <div class="py-3 border-bottom">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-sm-8 d-flex align-items-center">

                        <h5 class="m-0 p-0 align-self-center">
                            <a :href="'/teacher/courses'">
                                <i class="fas fa-tv mr-1"></i> Cursos
                            </a>
                        </h5>
                        <h5 class="m-0 p-0 ml-2 align-self-center">
                            <a :href="'/teacher/courses/'+ course.id + '/modules'">

                                <svg xmlns="http://www.w3.org/2000/svg" height="18px" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                                </svg>
                                {{ course.name }}
                            </a>
                        </h5>

                    </div>
<!--                    <div class="col-12 col-sm-4 d-flex justify-content-end">-->
<!--                        <div class="font-weight-bold-500 text-muted">-->
<!--                            {{ course.modules_duration_human }} de duração total do curso-->
<!--                        </div>-->
<!--                    </div>-->
                </div>
            </div>
        </div>
        <div class="container-md mx-auto">
            <div class="row d-flex justify-content-center mx-3" style="max-height: 400px;">
                <div class="col-12 col-md-9 px-0 pr-md-0" style="max-width: 720px; max-height: 400px;">
                    <div v-if="lesson.video_url">
                        <div style="padding:56.25% 0 0 0;position:relative; " class="">
                            <iframe :src="lesson.video_url" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen style="position:absolute;top:0;left:0;width:100%;height:100%;"></iframe>
                        </div>
                    </div>
                </div>
                <div class="d-none d-md-block col-3 pl-0 overflow-scroll" style="max-height: 400px;">
                    <div v-for="lessonItem in module.lessons" :key="lessonItem.id">
                        <div class="card d-flex flex-grow-1 border-bottom" role="button" @click="openLesson(lessonItem)">
                            <div class="card-body">
                                <div class="d-flex gap-2 align-items-center" >

                                    <svg height="22px" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.348a1.125 1.125 0 010 1.971l-11.54 6.347a1.125 1.125 0 01-1.667-.985V5.653z" />
                                    </svg>

                                    {{ lessonItem.name }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="bg-white border-top border-bottom">
            <div class="row d-flex justify-content-center mx-3">
                <div class="col-12 col-md-9 py-3" style="max-width: 720px;">
                    <span class="fs-4 fw-bolder text-dark">

                        {{lesson.name}}
                    </span>
                    <div class="mt-3" v-if="lesson.text">
                        <div class="fs-5 fw-medium text-dark">Conteúdo</div>
                        <div class="ql-editor" v-html="lesson.text.content"></div>
                    </div>
                    <div class="mt-3" v-if="lesson.files.length > 0">
                        <a role="button" class="fs-5" data-bs-toggle="collapse" data-bs-target="#lessonCollapse">
                            Material complementar
                        </a>

                        <div class="collapse card card-body border" id="lessonCollapse">
                            <div class="" v-for="file in lesson.files" :key="file.id">
                                <div class="d-flex">

                                    <div class="text-muted ">
                                        <i class="fas fa-file mr-2"></i>
                                        {{ file.name }}
                                    </div>
                                    <div class="ml-3 text-right">
                                        <a :href="file.preview" target="_blank">
                                            Baixar
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-3 py-3">
                    <div class="fw-medium text-dark">{{ lesson.views_count }} Visualizações</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['lesson', 'module', 'course'],
    data(){
        return {
            isMarked: false,
        }
    },
    created(){
        this.isMarked = this.lesson.views_count > 0;
    },
    mounted(){
    },
    methods: {
        openLesson(lesson){
            return window.location.href = '' + lesson.id;
        },
    }
}
</script>

<style>

</style>
